<template>
	<div class="dashboard stock-adjustment">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Add/Adjust Warehouse Product</h1>

		<div class="radioCheck">
			<b-radio v-model="type" name="name" native-value="create">Create</b-radio>
			<b-radio v-model="type" name="name" native-value="adjust">Adjust Stock</b-radio>
		</div>

		<b-field label="Select Warehouse (required)">
			<b-autocomplete
				v-model="warehouseSuggestions"
				:data="filteredWarehouse"
				:open-on-focus="true"
				placeholder="Warehouse"
				field="name"
				:disabled="disableShopSelector"
				@select="option => (selectedWarehouse = option)"
				class="shopAutoComplete"
			>
				<template slot="empty">No results found</template>
			</b-autocomplete>
		</b-field>

		<label class="csv-reader" v-if="selectedWarehouse">
			<input type="file" @change="loadTextFromFile" />
		</label>

		<h1 v-if="complete"><br /><br />Update Completed!</h1>

		<div v-if="totalCount > 0 && updatingCount == 0"><br /><br />Checking {{ checkingCount }} of {{ totalCount }}</div>

		<div v-if="updatingCount > 0"><br /><br />Updating {{ updatingCount }} of {{ totalCount }}</div>

		<div v-if="error"><br /><br />There is an error!</div>

		<div v-if="errorMessage.length > 0">
			<div v-for="(data, index) of errorMessage" v-bind:key="index">{{ data }}</div>
		</div>

		<div class="button-container" v-if="checkComplete && !error && !complete">
			<div class="big-button" @click="adjustStock()">
				Add/Update Now!
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'productsCheck',
	data: () => ({
		limit: 50,
		type: 'create',
		isLoading: false,
		totalCount: 0,
		checkingCount: 0,
		updatingCount: 0,
		checkComplete: false,
		complete: false,
		products: [],
		checkedProducts: [],
		invalidCode: [],
		validCode: [],
		warehouses: [],
		warehouseSuggestions: '',
		selectedWarehouse: null,
		error: false,
		errorMessage: [],
		disableShopSelector: false
	}),

	computed: {
		filteredWarehouse() {
			return this.warehouses.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.warehouseSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	mounted: async function() {
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}

		await this.getWarehouse()
	},

	watch: {},
	methods: {
		adjustStock: async function() {
			this.isLoading = true
			this.updatingCount = 0

			var i
			var skip
			var end
			var totalLoop = Math.ceil(this.totalCount / this.limit)

			for (i = 0; i < totalLoop; i++) {
				skip = i * this.limit
				end = skip + this.limit
				// Loop every row to put it in array

				const parallel = this.checkedProducts.slice(skip, end).map(async product => {
					this.updatingCount++

					if (this.type == 'create') {
						let { warehouse, product_id, stock } = product

						let data = {
							warehouse,
							product: product_id,
							stock
						}

						// if (increase) {
						// 	data.adjustments.stock = {
						// 		type: 'increase',
						// 		value: increase
						// 	}
						// } else {
						// 	data.adjustments.stock = {
						// 		type: 'decrease',
						// 		value: decrease
						// 	}
						// }

						let apiWarehouseProductCreate = await this.$api.createWarehouseProduct({ data })

						if (!apiWarehouseProductCreate) {
							this.error = true
							this.errorMessage.push(product.bd_code + ' has error while importing')
						}
					} else if (this.type == 'adjust') {
						let { warehouse, product_id, increase, decrease, description } = product

						let data = {
							warehouse,
							id: product_id,
							description,
							adjustments: {}
						}

						if (increase) {
							data.adjustments.stock = {
								type: 'increase',
								value: increase
							}
						} else {
							data.adjustments.stock = {
								type: 'decrease',
								value: decrease
							}
						}

						let apiWarehouseProductCreate = await this.$api.updateWarehouseProduct({ data })

						if (!apiWarehouseProductCreate) {
							this.error = true
							this.errorMessage.push(product.bd_code + ' has error while updating')
						}
					}
				})

				await Promise.all(parallel)
			}

			this.checkComplete = true
			this.complete = true
			this.isLoading = false

			if (this.error == true) {
				this.$swal.fire('Error!', 'There are a few errors!', 'error')
			} else {
				this.$swal.fire('Complete!', 'Latest Requests are Completed!', 'success')
			}
		},

		checkData: async function() {
			this.checkedProducts = []
			this.errorMessage = []
			var i
			var skip
			var end
			var totalLoop = Math.ceil(this.totalCount / this.limit)

			for (i = 0; i < totalLoop; i++) {
				skip = i * this.limit
				end = skip + this.limit

				// Loop every row to put it in array
				const parallel = this.products.slice(skip, end).map(async product => {
					this.checkingCount++
					var product_id
					if (this.type == 'create') {
						// To check if product is valid to create in warehouse
						let { warehouse, bd_code, stock } = product

						let productData = {
							bd_code: product.bd_code
						}

						const apiProductDetail = await this.$api.getProductDetail({ data: productData })

						if (apiProductDetail && apiProductDetail.data) {
							product_id = apiProductDetail.data._id
						} else {
							this.errorMessage.push('Cannot find ' + product.bd_code + ' in Server')
							this.error = true
							return
						}

						const apiGetWarehouseProduct = await this.$api.getWarehouseProducts({ data: { warehouse, products: { id: product_id } } })

						if (apiGetWarehouseProduct && apiGetWarehouseProduct.data.count > 0) {
							this.errorMessage.push(product.bd_code + ' is already in this warehouse!')
							this.error = true
							return
						}

						let newData = {
							warehouse,
							product_id,
							stock,
							bd_code
						}

						this.checkedProducts.push(newData)
					} else if (this.type == 'adjust') {
						// To check if product is valid in wearehouse
						let { warehouse, bd_code, increase, decrease, description } = product

						const apiGetWarehouseProduct = await this.$api.getWarehouseProducts({ data: { warehouse, products: { bd_code } } })

						if (apiGetWarehouseProduct && apiGetWarehouseProduct.data.count == 0) {
							this.errorMessage.push(product.bd_code + ' is NOT in this warehouse!')
							this.error = true
							return
						}

						product_id = apiGetWarehouseProduct.data.list[0]._id

						let newData = {
							warehouse,
							product_id,
							increase,
							decrease,
							bd_code,
							description
						}

						this.checkedProducts.push(newData)
					}
				})

				await Promise.all(parallel)
			}

			this.checkComplete = true

			this.isLoading = false
		},

		getShopProductsLoop: async function(data) {
			return await this.$api.shopProduct({ data })
		},

		// Load CSV and add into array
		loadTextFromFile(ev) {
			this.complete = false
			this.products = []
			this.error = false
			this.updatingCount = 0
			this.disableShopSelector = true
			this.totalCount = 0
			this.checkingCount = 0
			this.checkComplete = false
			this.checkedProducts = []
			var error = false
			const file = ev.target.files[0]
			const reader = new FileReader()

			// reader.onload = e => this.$emit("load", e.target.result);
			reader.onload = event => {
				var raw = event.target.result.split(/\r?\n/)

				var header = raw[0].split(/,/)

				let warehouse = this.selectedWarehouse._id
				let bdCode = header.indexOf('BD_CODE')

				if (this.type == 'create') {
					let stock_index = header.indexOf('STOCK')

					if (bdCode == -1) {
						this.$swal.fire('Cannot find BD_CODE')
						error = true
						this.isLoading = false
						return
					} else if (stock_index == -1) {
						this.$swal.fire('Cannot find STOCK')
						error = true
						this.isLoading = false
						return
					}

					// Remove first row
					raw.shift()

					// Error checking with loop
					raw.map(async data => {
						this.isLoading = true
						var splitData = data.split(/,/)

						// if bdcode is blank, exit now
						if (!splitData[bdCode]) {
							return
						} else {
							this.totalCount++
						}

						let stock = splitData[stock_index] ? splitData[stock_index] : 0

						let importProduct = {
							warehouse,
							bd_code: splitData[bdCode],
							stock
						}

						this.products.push(importProduct)
					})
				} else if (this.type == 'adjust') {
					let increase = header.indexOf('INCREASE')
					let decrease = header.indexOf('DECREASE')
					let description = header.indexOf('DESCRIPTION')

					if (bdCode == -1) {
						this.$swal.fire('Cannot find BD_CODE')
						error = true
						this.isLoading = false
						return
					} else if (increase == -1) {
						this.$swal.fire('Cannot find INCREASE')
						error = true
						this.isLoading = false
						return
					} else if (decrease == -1) {
						this.$swal.fire('Cannot find DECREASE')
						error = true
						this.isLoading = false
						return
					} else if (description == -1) {
						this.$swal.fire('Cannot find DESCRIPTION')
						error = true
						this.isLoading = false
						return
					}

					// Remove first row
					raw.shift()

					// Error checking with loop
					raw.map(async data => {
						this.isLoading = true
						var splitData = data.split(/,/)

						// if bdcode is blank, exit now
						if (!splitData[bdCode]) {
							return
						} else {
							this.totalCount++
						}

						if (splitData[increase] && splitData[decrease]) {
							this.$swal.fire({
								icon: 'info',
								title: 'Oops...',
								text: 'Cannot have both increase and decrease for ' + splitData[bdCode]
							})

							this.error = true
							return
						}

						if (!splitData[increase] && !splitData[decrease]) {
							this.$swal.fire({
								icon: 'info',
								title: 'Oops...',
								text: 'Cannot have BLANK for both increase and decrease for ' + splitData[bdCode]
							})

							this.error = true
							return
						}

						if (!splitData[description]) {
							this.$swal.fire({
								icon: 'info',
								title: 'Oops...',
								text: 'Cannot have BLANK description for ' + splitData[bdCode]
							})

							this.error = true
							return
						}

						let importProduct = {
							warehouse,
							bd_code: splitData[bdCode],
							increase: splitData[increase],
							decrease: splitData[decrease],
							description: splitData[description]
						}

						this.products.push(importProduct)
					})
				}

				// Continue if there are no errors
				if (!error) {
					this.checkData()
				}
			}

			reader.readAsText(file)
		},

		// Get list of shops
		getWarehouse: async function() {
			const apiGetWarehouse = await this.$api.getWarehouse({})

			this.warehouses = apiGetWarehouse.data.list
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
